import { Component } from '@angular/core';
import { ClothingListComponent } from './clothing-list/clothing-list.component';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzEmptyModule } from 'ng-zorro-antd/empty';

@Component({
  selector: 'app-clothing',
  standalone: true,
  imports: [NzGridModule, ClothingListComponent, NzSpinModule, NzEmptyModule],
  templateUrl: './clothing.component.html',
  styleUrl: './clothing.component.scss',
})
export class ClothingComponent {}
